function BottomNav({ view, setView, selectedEvent, setSelectedEvent, currentUser, eventCount }) {
  const items = [
    { key:"home", label:"Prossima", icon:(active)=>(
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={active?"#ED4D1D":"#B5AA9A"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 18V5l12-2v13"/>
        <circle cx="6" cy="18" r="3"/>
        <circle cx="18" cy="16" r="3"/>
      </svg>
    )},
    { key:"events", label:"Scopri", icon:(active)=>(
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={active?"#ED4D1D":"#B5AA9A"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8"/>
        <path d="m21 21-4.35-4.35"/>
      </svg>
    )},
    { key:"musicians", label:"Musicisti", icon:(active)=>(
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={active?"#ED4D1D":"#B5AA9A"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="7" r="3"/>
        <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        <path d="M21 21v-2a4 4 0 0 0-3-3.87"/>
      </svg>
    )},
    ...(currentUser?.is_admin ? [{ key:"venues", label:"Location", icon:(active)=>(
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={active?"#ED4D1D":"#B5AA9A"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    )}] : []),
  ];

  const activeKey = view === "home" ? "home" : (selectedEvent ? null : view);

  return (
    <nav className="bottom-nav">
      {items.map(item => {
        const active = activeKey === item.key;
        return (
          <button key={item.key}
            className={`bottom-nav-btn${active?" active":""}`}
            onClick={() => { setSelectedEvent(null); setView(item.key); window.scrollTo(0,0); }}>
            <div className="nav-icon">{item.icon(active)}</div>
            <span className="nav-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default BottomNav;
